import Close from "@mui/icons-material/Close";
import { Button, IconButton, Snackbar, SnackbarProps } from "@mui/material";

interface SelectedSnackbarProps extends SnackbarProps {
  numSelected: number;
  onRemove: () => void;
  onUnselect: () => void;
}

const SelectedSnackbar = ({
  numSelected,
  onRemove,
  onUnselect,
}: SelectedSnackbarProps) => {
  return (
    <Snackbar
      open={numSelected > 0}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      message={`${numSelected} selected`}
      action={
        <>
          <Button sx={{ color: "white" }} onClick={onRemove}>
            Remove
          </Button>
          <IconButton onClick={onUnselect}>
            <Close fontSize="small" sx={{ color: "white" }} />
          </IconButton>
        </>
      }
      sx={{ "& .MuiSnackbarContent-root": { minWidth: "460px" } }}
    />
  );
};

export default SelectedSnackbar;
